
import { NSFunctions } from './functions';

export let NSConfirm = {};

NSConfirm.init = function()
{
    NSConfirmPrivate.init();
	
    this.f_show =                            function () { return NSConfirmPrivate.f_show.apply( NSConfirmPrivate, arguments ); };
    this.f_hide =                            function () { return NSConfirmPrivate.f_hide.apply( NSConfirmPrivate, arguments ); };
	 	
    
	window.NSConfirm = NSConfirm;
	window.NSConfirmPrivate_ = NSConfirmPrivate;

	
}


let NSConfirmPrivate = {

	
	private_objs : 
	{
		e_div_confirm: null,
		e_button_ok: null,
		e_button_cancel: null,
		e_div_confirm_title: null,
		e_div_confirm_body: null,
		e_span_confirm_ok: null,
		e_span_confirm_cancel: null
  
	},
  

	init: function ()
	{
		var private_objs = this.private_objs;
		
		var s_html_base = `
			<div id="div_confirm" class="d-none">
				<div id="div_confirm_background"></div>
				<div id="div_confirm_content">
					<div id="div_confirm_title"></div>
					<div id="div_confirm_body"></div>
					<div id="div_confirm_actions">
						<button id="button_confirm_ok" type="button" class="btn btn-danger"><span id="span_confirm_ok"><b>Confirmar</b></span></button>
						<button id="button_confirm_cancel" type="button" class="btn btn-danger"><span id="span_confirm_cancel"><b>Cancelar</b></span></button>
					</div>
				</div>
			</div>
		`;
  
		//appending to element e_div_base
		private_objs.e_div_base = document.body;
		var e_div_base = private_objs.e_div_base;
		NSFunctions.f_dom_elem_append_dom_childs_by_html(e_div_base, s_html_base);                  
		
		var e_div_confirm = document.getElementById("div_confirm");
		private_objs.e_div_confirm = e_div_confirm;
		
		var e_button_confirm_ok = document.getElementById("button_confirm_ok");
		private_objs.e_button_confirm_ok = e_button_confirm_ok;
		
		var e_button_confirm_cancel = document.getElementById("button_confirm_cancel");
		private_objs.e_button_confirm_cancel = e_button_confirm_cancel;
		
		
		var e_div_confirm_title = document.getElementById("div_confirm_title");
		private_objs.e_div_confirm_title = e_div_confirm_title;
		
		var e_div_confirm_body = document.getElementById("div_confirm_body");
		private_objs.e_div_confirm_body = e_div_confirm_body;
		
		var e_span_confirm_ok = document.getElementById("span_confirm_ok");
		private_objs.e_span_confirm_ok = e_span_confirm_ok;
		
		var e_span_confirm_cancel = document.getElementById("span_confirm_cancel");
		private_objs.e_span_confirm_cancel = e_span_confirm_cancel;
	},

	/*
	o_in:
	{
		s_title_text,
		s_button_ok_text,
		s_button_cancel_text,
		s_text,
		
		f_on_ok_cb, // callback function
		f_on_cancel_cb, // callback function
	}
	*/
	f_show: function(o_in)
	{
		var this_ = this;
		var private_objs = this.private_objs;
		
		var s_title_text = (o_in.s_title_text != null)? o_in.s_title_text : "";
		var s_ok = (o_in.s_button_ok_text != null)? o_in.s_button_ok_text : "Continuar";
		var s_cancel = (o_in.s_button_cancel_text != null)? o_in.s_button_cancel_text : "Cancelar";
		var s_text = (o_in.s_text != null)? o_in.s_text : "";
		
		
		var e_div_confirm = private_objs.e_div_confirm;
		var e_button_confirm_ok = private_objs.e_button_confirm_ok;
		var e_button_confirm_cancel = private_objs.e_button_confirm_cancel;
		var e_div_confirm_title = private_objs.e_div_confirm_title;
		var e_div_confirm_body = private_objs.e_div_confirm_body;
		var e_span_confirm_ok = private_objs.e_span_confirm_ok;
		var e_span_confirm_cancel = private_objs.e_span_confirm_cancel;		
		
		e_div_confirm_title.innerHTML = s_title_text;
		e_div_confirm_body.innerHTML = s_text;
		e_span_confirm_ok.innerHTML = s_ok;
		e_span_confirm_cancel.innerHTML = s_cancel;
		
		e_button_confirm_ok.onclick = function ()
		{		
			this_.f_hide();
			o_in.f_on_ok_cb();
		};
		e_button_confirm_cancel.onclick = function ()
		{		
			this_.f_hide();
			o_in.f_on_cancel_cb();
		};
		
		e_div_confirm.classList.remove("d-none");
		
	},
	f_hide: function()
	{
		var private_objs = this.private_objs;
		var e_div_confirm = private_objs.e_div_confirm;

		e_div_confirm.classList.add("d-none");
	}
	
}

	/*
	NSConfirmPrivate
		init: init,
		f_show_div: f_show_error,

	}
	*/
	